<template>
    <div class="services py-5" :style="{ backgroundImage: `url('${image}')` }">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-6 col-lg-3 text-center p-0 service-single" v-animate="'fade-in'" v-for="(item, idx) in services" :key="idx">
                    <div class="thumbnail-classic flex-column" :class="$mq">
                        <div class="thumbnail-classic-icon">
                            <span :class="item.icon"></span>
                        </div>
                        <div class="thumbnail-classic-caption">
                            <h6 class="thumbnail-classic-title"><span>{{ item.title }}</span></h6>
                            <p class="thumbnail-classic-text" v-html="item.desc"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Services",

    props: {
        image: String
    },

    data() {
        return {
            services: [
                {
                    id: 0,
                    icon: "mdi icon mdi-tools",
                    title: "Précision",
                    desc: "À l'aide de son savoir-faire, <b>Blanchard</b> recherche toujours la perfection pour ses clients."
                },
                {
                    id: 1,
                    icon: "mdi icon mdi-code-tags-check",
                    title: "Commande numérique",
                    desc: "<b>Blanchard</b> utilise des machines à commande numérique à la pointe de la technologie."
                },
                {
                    id: 2,
                    icon: "mdi icon mdi-factory",
                    title: "Petites et moyennes séries",
                    desc: "Nos nombreuses machines nous permettent de produire des pièces mécaniques en série."
                },
                {
                    id: 3,
                    icon: "mdi icon mdi-cube-send",
                    title: "Toutes matières",
                    desc: "<b>Blanchard</b> travaille avec de nombreuses matières, telles que l'acier, l'inox ou l'aluminum."
                },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .services {
        background-size: cover;
        background-position: center;

        .service-single {
            .thumbnail-classic {
                .thumbnail-classic-icon {
                    margin-left: auto;
                    margin-right: auto;

                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 120px;
                    height: 120px;
                    margin-left: auto;
                    margin-right: auto;
                    color: $primary;
                    transition: 450ms ease-in-out;

                    &:after {
                        border-color: $primary;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        border: 3px solid $primary;
                    }
                    
                    &:before {
                        top: 50%;
                        bottom: 50%;
                        left: 50%;
                        right: 50%;
                        opacity: 0;
                        background: $primary;
                    }

                    &:after, &:before {
                        position: absolute;
                        content: "";
                        display: inline-block;
                        border-radius: 50%;
                        transition: 450ms ease-in-out;
                    }

                    .icon {
                        position: relative;
                        font-size: 48px;
                    }

                    &:hover {
                        color: $white;

                        &:after {
                            opacity: 0;
                        }

                        &:before {
                            top: 0;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            opacity: 1;
                            box-shadow: 0 8px 29px rgba(63, 9, 102, 0.25);
                        }
                    }
                }

                .thumbnail-classic-caption {
                    margin: 20px 0;
                    padding: 0 15px;

                    .thumbnail-classic-title {
                        font-size: 24px;
                        height: 58px;
                        text-transform: uppercase;
                        font-weight: 900;
                        position: relative;

                        span {
                            width: 100%;
                            position: absolute;
                            top: 50%;
                            left: 0;
                            transform: translateY(-50%);
                        }
                    }
                }

                &.mobile {
                    .thumbnail-classic-title {
                        height: auto;

                        span {
                            position: static;
                        }
                    }
                }
            }
        }
    }
</style>